"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Popover_1 = require("./Popover");
var epc_web_utils_1 = __importDefault(require("epc-web-utils"));
var defaultOptionalConfig = {
    showArrow: true
};
var PopoverPositionUtils = /** @class */ (function () {
    function PopoverPositionUtils(datum, popoverContentElem, popoverWrapper, optionalConfig) {
        if (optionalConfig === void 0) { optionalConfig = defaultOptionalConfig; }
        var _a;
        this.datum = datum;
        this.popoverContentElem = popoverContentElem;
        this.popoverWrapper = popoverWrapper;
        this.mainContentWrapper = (_a = popoverWrapper === null || popoverWrapper === void 0 ? void 0 : popoverWrapper.closest('.fds-main-content')) !== null && _a !== void 0 ? _a : document.querySelector('.fds-main-content');
        this.epcTopBar = document.querySelector('.epc-top-header');
        this.arrowVisible = optionalConfig.showArrow;
        this.topIntersectionElemId = optionalConfig.topIntersectionElemId;
        this.edgeMargin = 12;
    }
    PopoverPositionUtils.prototype.getPopoverPosition = function () {
        // Determine where the left edge of the Popover content should be
        var leftOffset = this.datum.getBoundingClientRect().left - (this.popoverContentElem.getBoundingClientRect().width / 2) + (this.datum.getBoundingClientRect().width / 2);
        // Determine offset of main content wrapper to prevent nav clipping
        // const mainContentWrapperLeftOffset = elemMainContentWrapper ? elemMainContentWrapper.getBoundingClientRect().left : 0;
        var mainContentWrapperLeftOffset = this.mainContentWrapper ? this.mainContentWrapper.getBoundingClientRect().left : 0;
        // If left edge clips over nav, adjust left edge to not clip (and give it a gutter)
        if (mainContentWrapperLeftOffset > leftOffset) {
            leftOffset = mainContentWrapperLeftOffset + this.edgeMargin;
        }
        // Make sure that there's no possibility of clipping outside the viewport
        var safeLeftOffset = this.calcSafeLeftOffset(this.popoverContentElem, leftOffset);
        // Determine offset top calculation based on if Popover is set to top or bottom position
        var orientation = this.getPopoverOrientation(this.popoverContentElem, this.datum, this.topIntersectionElemId);
        var topOffset = orientation === Popover_1.PopoverOrientation.TOP ? this.datum.offsetTop - this.popoverContentElem.offsetHeight + "px" : this.datum.offsetTop + this.datum.offsetHeight + "px";
        var result = {
            popoverStyle: {
                top: topOffset,
                left: safeLeftOffset + "px"
            },
            orientation: orientation
        };
        if (this.arrowVisible) {
            result = __assign(__assign({}, result), { arrowStyle: {
                    left: this.getArrowPosition(safeLeftOffset)
                } });
        }
        return result;
    };
    PopoverPositionUtils.prototype.getArrowPosition = function (popoverLeftOffset) {
        var datumWidth = this.isRTL() ? (this.datum.getBoundingClientRect().width / 2) - 6 : this.datum.getBoundingClientRect().width / 2;
        // Calculate the delta between the center of the trigger and the left edge of the popover
        // to determine how far away from the left edge of the popover the arrow should be
        return (this.datum.offsetLeft - popoverLeftOffset) + datumWidth + "px";
    };
    PopoverPositionUtils.prototype.getPopoverOrientation = function (popoverElem, datum, topIntersectionElemId) {
        // Height of PC top nav in Prod + top page gutter so flip decision considers the top nav instead of just the top of the viewport
        var topNavSafeOffset = this.epcTopBar ? this.epcTopBar.getBoundingClientRect().height + this.edgeMargin : 0;
        var availableVerticalDistance = datum.getBoundingClientRect().top - topNavSafeOffset;
        // If an id for a custom intersection elem is defined, then calc the available vertical distance for the popover as the difference 
        // between the bottom of that element and the top of the popover trigger instead of the top of the viewport and the top of the popover trigger
        if (topIntersectionElemId) {
            var intersectionElem = document.getElementById(topIntersectionElemId);
            if (intersectionElem) {
                var intersectionElemDist = availableVerticalDistance - (intersectionElem.getBoundingClientRect().bottom - topNavSafeOffset);
                // Only update the available vertical distance if intersection elem is above the trigger
                if (intersectionElemDist > 0) {
                    availableVerticalDistance = intersectionElemDist;
                }
            }
        }
        return availableVerticalDistance - popoverElem.offsetHeight > 0 ? Popover_1.PopoverOrientation.TOP : Popover_1.PopoverOrientation.BOTTOM;
    };
    PopoverPositionUtils.prototype.calcSafeLeftOffset = function (element, offset) {
        var newOffset = epc_web_utils_1.default.getSafeWindowOffset(element, offset);
        // LTR - Factor in page margin if the offset was corrected by WebUtils
        if (newOffset !== offset) {
            newOffset = newOffset > 0 ? newOffset - this.edgeMargin : newOffset + this.edgeMargin;
        }
        if (this.isRTL()) {
            var availableWidth = this.mainContentWrapper.getBoundingClientRect().width - this.edgeMargin;
            var neededWidth = element.getBoundingClientRect().width + newOffset;
            var widthDifference = neededWidth - availableWidth;
            // Reduce left offset by amount popover would clip over left nav
            if (widthDifference > 0) {
                newOffset = newOffset - widthDifference;
            }
        }
        // Determine correct offset by subtracting the offset of the parent since the correct offset 
        // needs to be set in context of the parent (relative positioning) not the viewport
        return newOffset - this.popoverWrapper.getBoundingClientRect().left;
    };
    PopoverPositionUtils.prototype.isRTL = function () {
        return document.documentElement.dir.toLowerCase() === 'rtl';
    };
    return PopoverPositionUtils;
}());
exports.default = PopoverPositionUtils;
